import { PropsWithChildren } from 'react'

import { AppProvider } from '@shopify/polaris'
import translationsCs from '@shopify/polaris/locales/cs.json'
import translationsEn from '@shopify/polaris/locales/en.json'

import { getAppLocale } from '../util/getTranslation'

export function I18nProvider({ children }: PropsWithChildren<{}>) {
  const locale = getAppLocale()
  const polarisTranslations = locale === 'cs' || locale === 'cs-CZ' ? translationsCs : translationsEn

  return <AppProvider i18n={polarisTranslations}>{children}</AppProvider>
}
